import TagPicker from 'library/components/form/tag-picker';
import WishlistSwitch from 'library/components/form/wishlist-checkbox';
import useTagList from 'library/hooks/use-deferred-data/use-tag-list';
import Input from 'library/components/form/input';
import TextArea from 'library/components/form/textarea';
import { useMemo } from 'react';
import {
  ButtonFileContainer, Icon, ButtonFile, FieldContainer,
} from './styles';
import useManufacturerList from '../../hooks/use-deferred-data/use-manufacturer-list';
import useStorageList from '../../hooks/use-deferred-data/use-storage-list';

export default ({
  isCreate = false,
  isEditable = false,
  labelMaps,
  modalFieldHandlers: {
    handleUploadModalOpen,
    handlePickCategoryModalOpen,
    handleAddToSetModalOpen,
    handleSearchByColorModalOpen,
  },
  disabledFields = [],
  onTagPickerInteract,
}) => {
  const {
    onQueryChange: onTagQueryChange, options: tagsOptions, labelMap, isLoading: isTagListLoading, nameMap,
  } = useTagList(
    false,
  );
  const {
    options: manufacturers, onQueryChange: onManufacturerQueryChange, labelMap: manufacturerLabelMap, isLoading: isManufacturerListLoading,
  } = useManufacturerList(
    false,
    labelMaps.manufacturerMap || {},
  );

  const manufacturersOptions = useMemo(() => manufacturers.map(({ value: id, text: name }) => ({ id, name })), [isManufacturerListLoading, manufacturerLabelMap]);
  const manufacturerLabelToIdsMapFormatted = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(manufacturerLabelMap));
    const result = {};
    Object.entries(copy).forEach(([key, value]) => {
      result[value] = key;
    });
    return result;
  }, [isManufacturerListLoading, manufacturerLabelMap]);

  const {
    labelMap: storagesLabelMap, options: storages, onQueryChange: onStorageQueryChange, isLoading: isStorageListLoading,
  } = useStorageList(false, labelMaps.manufacturerMap || {});

  const storagesOptions = useMemo(() => storages.map(({ value: id, text: name }) => ({ id, name })), [isStorageListLoading, storagesLabelMap]);
  const storageLabelToIdsMapFormatted = useMemo(() => {
    const copy = JSON.parse(JSON.stringify(storagesLabelMap));
    const result = {};
    Object.entries(copy).forEach(([key, value]) => {
      result[value] = key;
    });
    return result;
  }, [isStorageListLoading, storagesLabelMap]);

  return (
    <FieldContainer>
      {
        isEditable && (
          <ButtonFileContainer>
            <ButtonFile onClick={handleUploadModalOpen}>
              <Icon className="icon-picture" />
              Add image from ...
            </ButtonFile>
          </ButtonFileContainer>
        )
      }
      {isEditable ? (
        <Input
          placeholder="Name this item (required)"
          iconClassName="icon-pencil"
          name="name"
          required={isCreate}
          readOnly={!isEditable}
          isClearable={isEditable}
          isFocusedOnMount={isCreate && isEditable}
        />
      ) : null}
      <Input
        placeholder="Select a category (required)"
        iconClassName="icon-category"
        name="category"
        formatterMap={labelMaps.categoryMap}
        required={isCreate}
        onClick={isEditable ? handlePickCategoryModalOpen : undefined}
        readOnly
      />
      <Input
        placeholder="Add to set"
        iconClassName="icon-set"
        name="sets"
        formatterMap={labelMaps.setMap}
        onClick={(isEditable && !disabledFields.includes('sets')) ? handleAddToSetModalOpen : undefined}
        readOnly={!isEditable}
        isSetField
      />
      <Input
        placeholder="Colors"
        iconClassName="icon-colors"
        name="colors"
        isColorField
        onClick={isEditable ? handleSearchByColorModalOpen : undefined}
        readOnly={!isEditable}
      />
      <Input
        type="number"
        placeholder="Quantity on hand"
        iconClassName="icon-layers"
        name="count"
        readOnly={!isEditable}
        min={0}
      />
      <TagPicker
        placeholder="Add tags"
        name="tags"
        options={tagsOptions}
        formatterMap={labelMap}
        nameMap={nameMap}
        readOnly={!isEditable}
        isLoading={isTagListLoading}
        // defaultValue={data ? data?.tags?.map((t) => t.id) : undefined}
        onQueryChange={onTagQueryChange}
        onInteract={onTagPickerInteract}
      />
      <TagPicker
        isSingleOption
        icon="icon-manufacturer"
        placeholder="Add manufacturer"
        name="manufacturer"
        options={manufacturersOptions}
        formatterMap={manufacturerLabelMap}
        nameMap={manufacturerLabelToIdsMapFormatted}
        readOnly={!isEditable}
        isLoading={isManufacturerListLoading}
        // defaultValue={data?.manufacturer_id ? [data?.manufacturer_id] : []}
        onQueryChange={onManufacturerQueryChange}
        minQueryLength={1}
        onInteract={onTagPickerInteract}
      />
      <TagPicker
        isSingleOption
        icon="icon-drawer"
        placeholder="Add storage"
        name="storage"
        options={storagesOptions}
        formatterMap={storagesLabelMap}
        nameMap={storageLabelToIdsMapFormatted}
        readOnly={!isEditable}
        isLoading={isStorageListLoading}
        // defaultValue={data?.storage_id ? [data?.storage_id] : undefined}
        onQueryChange={onStorageQueryChange}
        minQueryLength={1}
        onInteract={onTagPickerInteract}
      />
      <Input
        placeholder="Barcode"
        iconClassName="icon-barcode"
        name="barcode"
        readOnly={!isEditable}
        isClearable={isEditable}
      />
      <Input
        type="number"
        placeholder="Price"
        iconClassName="icon-price"
        name="price"
        readOnly={!isEditable}
      />
      <TextArea
        placeholder="Notes"
        iconClassName="icon-notes"
        name="note"
        readOnly={!isEditable}
        autoComplete="off"
        isClearable={isEditable}
        role="presentation"
      />
      {!isCreate && isEditable ? (
        <WishlistSwitch
          name="is_wishlisted"
          iconClassName="icon-heart"
        />
      ) : null}
    </FieldContainer>
  );
};
